import { render, staticRenderFns } from "./ReminderEditorItem.vue?vue&type=template&id=58da9922&"
import script from "./ReminderEditorItem.vue?vue&type=script&lang=js&"
export * from "./ReminderEditorItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports